import useAxios from 'hooks/useAxios';

export async function getBanners() {
  const api = useAxios();

  try {
    const res = await api.get('/banners');
    return res;
  } catch (err) {
    return err;
  }
}


